/**
 * 报告查询相关路由
 */
export default [
  {
    path: '/report',
    component: () => import('Pages/report/index.vue')
  },
  /**
   * 检验报告
   */
  {
    path: '/report/inspection',
    component: () => import('Pages/report/inspection/list.vue')
  },
  {
    path: '/report/inspection/:id',
    props: true,
    component: () => import('Pages/report/inspection/details.vue')
  },
  /**
   * 检查报告
   */
  {
    path: '/report/check',
    component: () => import('Pages/report/check/list.vue')
  },
  {
    path: '/report/check/:id',
    component: () => import('Pages/report/check/details.vue')
  },
  /**
   * 体检报告
   */
  {
    path: '/report/medical',
    component: () => import('Pages/report/medical/list.vue')
  },
  {
    path: '/report/medical/:id',
    props: true,
    component: () => import('Pages/report/medical/details.vue')
  },
  {
    path: '/queryReport/sendPhoneCode',
    props: true,
    component: () => import('Pages/report/medical/sendPhoneCode.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/report.js